{
  "ACTION": {
    "CLEAR_FILTER": "Borrar",
    "CONTINUE": "Continuar",
    "EDIT": "Modificar",
    "SEND": "Enviar",
    "VALIDATE": "Validar"
  },
  "ARIA": {
    "MENU": "Menú principal"
  },
  "COMPONENT": {
    "AGENDA-MAGASIN-TUNNEL": {
      "I_WANT_TO_TAKE_MY_APPOINTMENT": "Quiero hacer mi cita",
      "IN_STORE": "En tienda",
      "REMOTELY": "En videollamada"
    },
    "AVIS-GOOGLE": {
      "OUT_OF": "de",
      "REVIEWS": "Reseñas"
    },
    "AVIS-GOOGLE-DETAILS": {
      "AVERAGE_RATING_DISCLAIMER": "Esta puntuación se ha calculado a partir de las <strong>{{nbReviews}} opiniones publicadas en Google*</strong> por nuestros clientes tras su experiencia en nuestras tiendas SoCoo'c en toda Francia. *Estas opiniones no han sido verificadas.",
      "AVERAGE_RATING_DISCLAIMER_STORE": "Esta puntuación se ha obtenido recopilando las <strong>{{nbReviews}} opiniones de Google*</strong> que nuestros clientes han dejado en nuestra tienda tras su experiencia con SoCoo'c. *Nuestras opiniones de Google no han sido verificadas.",
      "REVIEWS_STAR": "Las reseñas de {{count}} estrella:",
      "REVIEWS_STARS": "Las reseñas de {{count}} estrellas:",
      "SEE_MORE_REVIEWS": "Ver más opiniones",
      "SORT_BY_HIGHEST_TO_LOWEST_RATED": "De mejor valorado a peor valorado:"
    },
    "CARTE-OPPORTUNITES": {
      "OPENING_OPPORTUNITIES": "Oportunidades de apertura",
      "OVERSEAS_OPPORTUNITIES": "Nuestras oportunidades internacionales",
      "STORES_OPEN": "Tiendas abiertas"
    },
    "CONFIRMATION-RDV": {
      "THANK_YOU_RESPONSE": "Gracias por su respuesta"
    },
    "CONFIRMATION-RDV-ESPACE-CLIENT": {
      "ADD_TO_CALENDAR": "Añadir a mi calendario",
      "CALENDAR_EVENT_TITLE": "Cita {{store}}",
      "IMPEDIMENT_TITLE": "¿Algún imprevisto?",
      "IMPEDIMENT_TEXT": "Avísanos para que no preparemos el café demasiado pronto ;) Es muy sencillo con tu área de cliente SoCoo'c: puedes modificar o cancelar tu cita.",
      "CREATE_ACCOUNT": "Creo mi cuenta SoCoo'c",
      "LOGIN": "Inicio sesión",
      "MY_ACCOUNT": "Accedo a mi cuenta SoCoo'c"
    },
    "CONTENU-ARTICLE": {
      "MINUTE": "{{count}} minuto",
      "MINUTES": "{{count}} minutos",
      "READING_TIME_LABEL": "Tiempo de lectura:"
    },
    "ENCART-INFOS-MAGASIN": {
      "CLOSED": "Cerrado",
      "EXCEPTIONAL_CLOSURE": "Cierre excepcional",
      "EXCEPTIONAL_OPENING": "Obertura excepcional",
      "SHOW_ALL_REVIEWS": "Ver todas las reseñas"
    },
    "ESTIMATEUR-BUDGET-DETAIL-PRIX": {
      "CALCULATING_CURRENT_PRICE": "Càlcul del preu en curs",
      "DELIVERY_INCLUDED": "Entrega incluida",
      "PRICE_BREAKDOWN_DETAIL": "Detall del preu",
      "STARTING_FROM_PER_MONTH": "Desde {{price}}/mois"
    },
    "ESTIMATEUR-BUDGET-SELECTION": {
      "ESTIMATION_INDEX": "Estimación {{ index }}",
      "HOUSEHOLD_APPLIANCE": "Electrodomésticos",
      "MY_ESTIMATIONS": "Mis estimaciones",
      "MY_SELECTION": "Mi selección",
      "PRICE_RANGE": "Entre {{ minPrice }} y {{ maxPrice }}",
      "REQUEST_NEW_ESTIMATE": "Nueva estimación",
      "SEND_BY_EMAIL": "Enviar por correo electrónico"
    },
    "ESTIMATEUR-ETAPE": {
      "HEADER": {
        "APPLIANCES_AND_PLUMBING_LABEL": "Electrodomésticos y sanitarios",
        "DELIVERY_AND_INSTALLATION_LABEL": "Entrega e instalación",
        "FURNITURE_LABEL": "Muebles",
        "PRICE_ESTIMATE_LABEL": "Estimación"
      },
      "I_DONT_NEED_ANYTHING": "No necesito nada"
    },
    "FORMULAIRE-CATALOGUE": {
      "CATALOG_SENT_TO_EMAIL": "Tu catálogo ha sido enviado por email a la dirección {{ email }}.",
      "CATALOG_WAITING_IN_MAILBOX": "Tu catálogo te espera en tu correo.",
      "CHECK_SPAM_IF_NOT_RECEIVED": "Si tras unos minutos no lo has recibido, revisa tu carpeta de spam.",
      "DOWNLOAD_CATALOG": "Descargar el catálogo",
      "FORM_ERROR": "Error al enviar el formulario.",
      "LABEL_EMAIL": "Mi correo electrónico:"
    },
    "FORMULAIRE-CONTACT-B2B": {
      "DEVELOPER_SECTION_DESCRIPTION": "Seleccione el departamento de implantación deseado para descubrir quién es su desarrollador a cargo",
      "DEVELOPER_SECTION_TITLE": "¡Nuestro equipo de desarrollo a su servicio!",
      "LABEL_AREA": "Departamento de implantación:",
      "LABEL_EMAIL": "Mi dirección de correo:",
      "LABEL_FIRST_NAME": "Mi nombre:",
      "LABEL_LAST_NAME": "Mi apellido:",
      "LABEL_MESSAGE": "Un mensaje para nuestros desarrolladores:",
      "LABEL_PHONE": "Mi número de teléfono:",
      "MESSAGE_CONFIRMATION_RESPONSE_SOON": "Su mensaje ha sido transmitido a nuestros equipos, le responderemos en breve.",
      "MESSAGE_HELPER_TEXT": "Dénos algunos detalles sobre su proyecto: ciudad(es) de implantación deseada(s), sus experiencias, ..."
    },
    "FORMULAIRE-RDV": {
      "FORM_PLACEHOLDER_MESSAGE": "¿Ya ha conocido a alguno de nuestros Kitcheners o le gustaría conocer a uno en particular?\n¿Tiene un proyecto de cocina? ¿O necesita información?",
      "LABEL_APPOINTMENT": "Tu cita:",
      "LABEL_APPOINTMENT_DATETIME": "a las",
      "LABEL_CUSTOM_MESSAGE": "¿Un mensaje personalizado?",
      "LABEL_STORE_LOCATION": "En tu tienda ",
      "LABEL_WHEN": "Cuándo",
      "LABEL_WHERE": "Dónde",
      "VIDEO_APPOINTMENT_WITH_STORE": "En videollamada con tu tienda"
    },
    "HERO-MODELE": {
      "ALL_OUR_FINISHES": "Todos nuestros acabados",
      "KITCHEN_LAYOUT_WITH_SURFACE": "Cocina {{type}} de {{surface}}"
    },
    "HERO-SLIDER": {
      "VIRTUAL_TOUR": "Visita virtual"
    },
    "KITCHEN-MODEL-CARD": {
      "SEE_THIS_KITCHEN": "Ver esta cocina"
    },
    "LISTING-AUTRES-FACADES": {
      "OTHER_FRONTS": "Los otros frentes"
    },
    "LISTING-COIN-REPAS": {
      "FROM": "Desde:",
      "PER_UNIT": "la unidad"
    },
    "LISTING-FACADES": {
      "NO_RESULTS": "Sin resultados para este tipo de frente."
    },
    "LISTING-MAGASIN": {
      "SEE_THIS_STORE": "Ver esta tienda"
    },
    "LISTING-MEUBLES-IMAGE-NOM-DESCRIPTION": {
      "AVAILABLE_HEIGHTS": "Alturas disponibles",
      "AVAILABLE_WIDTHS": "Anchuras disponibles"
    },
    "LISTING-PACK-PRODUITS": {
      "FOR_THE_SET": "El lote",
      "INSTEAD_OF": "En vez de:"
    },
    "LISTING-TEMOIGNAGES": {
      "SEE_MORE_TESTIMONIES": "Ver más testimonios"
    },
    "MAP-POPIN": {
      "WANT_TO_KNOW_MORE_OPPORTUNITY": "¿Quieres saber más sobre esta oportunidad?"
    },
    "MENU-BLOG": {
      "THE_BLOG": "El blog",
      "THE_SECTIONS": "Los temas"
    },
    "MENU-TUNNEL": {
      "CONTACT_DETAILS": "Contacto",
      "DAY_AND_TIME": "Días y horario",
      "STORE": "Tienda"
    },
    "POPIN-ESTIMATION-EMAIL": {
      "ALL_GOOD": "¡Todo listo!",
      "ESTIMATE_SENT_CONFIRMATION": "<p>Su estimación le ha sido enviada por correo electrónico a la dirección  {{email}}.</p><p>Si después de unos minutos no la ha recibido, compruebe la carpeta de spam.</p>",
      "MY_EMAIL_ADDRESS": "Mi dirección de correo electrónico",
      "PRIVACY_POLICY_REMINDER": "Para saber cómo utilizamos los datos recopilados en este formulario y ejercer sus derechos sobre sus datos personales, especialmente de acceso y supresión, consulte nuestra <strong><a target=\"_blank\"  class=\"cursor-pointer\" href=\"{{privacyPolicyUrl}}\">política de privacidad</a></strong>.",
      "SEND_ESTIMATE": "Enviar la estimación",
      "SEND_KITCHEN_ESTIMATE_BY_EMAIL": "Enviar la estimación de mi cocina por correo electrónico"
    },
    "POPIN-PRICE-DETAIL": {
      "LOADING_PRICE_DETAILS": "Cargando el detalle del precio"
    },
    "POPIN-REALISATIONS-CLIENTS": {
      "CREATED_BY": "Realizada por:",
      "NEXT_KITCHEN": "Cocina siguiente",
      "PREVIOUS_KITCHEN": "Cocina anterior"
    },
    "SEARCH": {
      "LABEL_MY_CITY": "Localidad"
    },
    "STORE-LOCATOR": {
      "BOOK_APPOINTMENT": "Pedir cita",
      "DISTANCE_IN_KM": "A {{km}} km",
      "PLACEHOLDER_CITY_OR_POSTAL_CODE": "Ciudad o código postal",
      "SELECT_THIS_STORE": "Elegir esta tienda",
      "VIDEO_APPOINTMENT_AVAILABLE": "Cita videollamada disponible"
    },
    "TEXTE-SEO": {
      "SEE_LESS": "Mostrar menos",
      "SEE_MORE": "Mostrar más"
    },
    "TITRE-FILTRES-MODELES": {
      "BUDGET_PLACEHOLDER": "Presupuesto",
      "CHOOSE_ACTION": "Yo elijo",
      "KITCHEN_FRONTS_PLACEHOLDER": "los frentes",
      "KITCHEN_LAYOUT": "mi distribución",
      "LAYOUT_PLACEHOLDER": "Distribución",
      "OUR_SELECTION": "Nuestra selección",
      "PRICE_ASCENDING": "De menor a mayor precio",
      "PRICE_DESCENDING": "De mayor a menor precio",
      "PRICE_LESS_THAN": "Menos de {{amount}} €",
      "PRICE_MORE_THAN": "Más de {{amount}} €",
      "PRICE_RANGE": "Entre {{min}} € y {{max}} €",
      "PS_LOVE": "PD: Me encanta",
      "RESET_FILTERS": "Restablecer filtros",
      "SEARCH_KITCHEN": "Busco una cocina"
    }
  },
  "ELASTIC_SEARCH": {
    "GET-CABINET-BODIES-QUERY": {
      "CABINET_BODY": "Cuerpos de mueble"
    },
    "GET-COUNTERTOPS-QUERY": {
      "WORKTOPS": "Encimeras"
    },
    "GET-FRONTS-QUERY": {
      "KITCHEN_FRONTS": "Frentes"
    },
    "GET-HANDLES-QUERY": {
      "HANDLES": "Tiradores"
    }
  },
  "GLOBAL": {
    "AND": "Y",
    "APPLIANCES_AND_SANITARY": "Electrodomésticos y sanitarios",
    "BACK": "Volver",
    "BETWEEN": "Entre",
    "BUDGET": "Presupuesto:",
    "CALL_TO_ACTION_CALL_US": "Truca'ns",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS": "Llama a {{storeName}} al <strong><a href=\"{{storePhoneTelLink}}\" style=\"white-space: nowrap;\">{{storePhoneFormatted}}</a></strong> para saber qué citas hay disponibles",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS_NO_PHONE": "Contacta con {{storeName}} para saber qué citas hay disponibles",
    "CONTACT_US": "Contáctanos",
    "FIELD_MIN_LENGTH_ERROR": "Por favor, introduzca al menos 3 caracteres",
    "FINISHES": "Acabados",
    "FORMS": {
      "APPOINTMENT_SERVER_ERROR": "El servicio de citas no está disponible en este momento. Le recomendamos que llame a la tienda al {{phone}} o que vuelva a intentarlo dentro de unos minutos.",
      "APPOINTMENT_SERVER_ERROR_NO_PHONE": "El servicio de citas no está disponible en este momento. Le recomendamos que vuelva a intentarlo dentro de unos minutos.",
      "AREA_REQUIRED_ERROR": "El departamento es obligatorio",
      "CALLBACK_REQUEST_PROMPT": "¿Quieres que te llamemos?",
      "CHECKBOX_REQUIRED_ERROR": "Debes marcar al menos una opción",
      "CITY_REQUIRED_ERROR": "La ciudad es obligatoria",
      "EMAIL_INVALID_ERROR": "El correo electrónico no es válido",
      "EMAIL_REQUIRED_ERROR": "El correo electrónico es obligatorio",
      "FIRST_NAME_MIN_LENGTH_ERROR": "El nombre debe tener al menos 3 caracteres",
      "GENDER_REQUIRED_ERROR": "El género es obligatorio",
      "INTEREST_REQUIRED_ERROR": "El motivo de su interés es obligatorio",
      "LABEL_CITY": "Ciudad:",
      "LABEL_EMAIL": "Correo electrónico:",
      "LABEL_FIRST_NAME": "Nombre:",
      "LABEL_INFORMATION_TYPE": "Tipo de información:",
      "LABEL_LAST_NAME": "Apellido:",
      "LABEL_MESSAGE": "Mensaje:",
      "LABEL_NEWSLETTER_OPTIN": "¿Deseas recibir noticias y ofertas de SoCoo'c?",
      "LABEL_OPTIN_EMAIL": "Por correo electrónico",
      "LABEL_OPTIN_SMS": "Por SMS",
      "LABEL_PHONE": "Teléfono:",
      "LABEL_REQUEST_TYPE": "Tipo de solicitud:",
      "LABEL_STORE": "Tienda",
      "LABEL_TITLE_MADAM": "Señora",
      "LABEL_TITLE_MISTER": "Señor",
      "LABEL_ZIPCODE": "Código postal:",
      "LAST_NAME_MIN_LENGTH_ERROR": "El apellido debe tener al menos 2 caracteres",
      "MESSAGE_RECEIVED_CONFIRMATION": "Hem rebut el teu missatge. Et respondrem al més aviat possible!",
      "MESSAGE_REQUIRED_ERROR": "El mensaje es obligatorio",
      "PHONE_FORMAT_ERROR": "El número de teléfono no tiene un formato válido",
      "PHONE_REQUIRED_ERROR": "El número de teléfono es obligatorio",
      "REQUEST_INFORMATION_TYPE_REQUIRED_ERROR": "Has d’indicar el tipus d’informació",
      "REQUEST_ORDER_TYPE_REQUIRED_ERROR": "Debe indicarse la tienda",
      "REQUEST_TYPE_REQUIRED_ERROR": "El tipo de solicitud es obligatorio",
      "ZIPCODE_FORMAT_ERROR": "El código postal no tiene un formato válido",
      "ZIPCODE_NOT_FOUND_ERROR": "Código postal no reconocido, por favor introduzca otro código postal",
      "ZIPCODE_REQUIRED_ERROR": "El código postal es obligatorio"
    },
    "FURNITURE": "Muebles",
    "INCLUDING_ECO_PART": "incluidos {{price}} de ecoparticipación",
    "INCLUDING_X_ENVIRONMENTAL_TAX": "incluyendo {{environmentalTaxPrice}} de tasa ecológica",
    "INSTALLATION_AND_DELIVERY": "Instalación y entrega",
    "KITCHEN": "Cocina",
    "LOADING_OPENING_HOURS": "Cargando los horarios",
    "LOADING_TIME_SLOTS": "Cargando los horarios",
    "NO": "No",
    "PUNCTUATION": {
      "COLON": ":"
    },
    "SEE_MORE": "Mostrar más",
    "SEE_MORE_TIME_SLOTS": "Ver más horarios disponibles",
    "STORE_CLOSED_TODAY": "Cerrado hoy",
    "STORE_OPEN_TODAY": "Abierto hoy",
    "VIEW_PRICE_DETAILS": "Ver el detalle del precio",
    "YES": "Sí"
  },
  "MIDDLE_OFFICE": {
    "LOGOUT": "Tancar sessió"
  },
  "PRICE": {
    "ECO_PART": "incluidos {{ecoPart}} de eco-participación"
  },
  "SCHEMA_JSON_LD": {
    "BLOG_MENU": "Menú del blog",
    "FOOTER_MENU": "Menú del pie de página",
    "MAIN_MENU": "Menú principal"
  }
}
